import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';

// One collapsible panel per day that has tow sheets. The first day starts open.
const TowSheetDays = ({ invoiceList, renderDay }) => {
    const days = (invoiceList || []).filter((item) => Object.keys(item.attachments || {}).length > 0);
    const [open, setOpen] = useState(() => new Set(days.length ? [0] : []));

    if (days.length === 0) {
        return (
            <Paper variant="outlined" sx={{ py: 6, textAlign: 'center' }}>
                <Typography color="text.secondary">No tow sheets for this month.</Typography>
            </Paper>
        );
    }

    const toggle = (index) =>
        setOpen((prev) => {
            const next = new Set(prev);
            if (next.has(index)) next.delete(index);
            else next.add(index);
            return next;
        });

    return days.map((day, index) => {
        const count = Object.keys(day.attachments).length;
        return (
            <Accordion
                key={`${day.createdDate}-${index}`}
                disableGutters
                variant="outlined"
                expanded={open.has(index)}
                onChange={() => toggle(index)}
                sx={{ mb: 1, '&:before': { display: 'none' }, borderRadius: 1.5, overflow: 'hidden' }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, flex: 1 }}>{moment(day.createdDate).format('dddd, MMM D, YYYY')}</Typography>
                    <Typography color="text.secondary" sx={{ mr: 1 }}>
                        {count} {count === 1 ? 'tow sheet' : 'tow sheets'}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: 'background.default', borderTop: 1, borderColor: 'divider' }}>
                    {renderDay(day.attachments)}
                </AccordionDetails>
            </Accordion>
        );
    });
};

export default TowSheetDays;
